export default "__VITE_ASSET__wfX9g8Zp__"